
import React from 'react';
import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Home, ArrowLeft, Phone, Mail } from 'lucide-react';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  const suggestedPages = [
    { name: 'Startseite', href: '/', description: 'Zurück zur Hauptseite' },
    { name: 'Über uns', href: '/uber-uns', description: 'Erfahren Sie mehr über AMMING' },
    { name: 'Leistungen', href: '/leistungen', description: 'Unsere Bauleistungen im Überblick' },
    { name: 'Kontakt', href: '/kontakt', description: 'Nehmen Sie Kontakt mit uns auf' }
  ];

  return (
    <>
      <SEO
        title="Seite nicht gefunden - AMMING GmbH"
        description="Die angeforderte Seite konnte nicht gefunden werden. Entdecken Sie unsere Bauleistungen oder kontaktieren Sie uns direkt."
        canonical={`${window.location.origin}/404`}
      />
      
      <div className="min-h-screen flex flex-col bg-white">
        <main className="flex-1 flex items-center justify-center px-4 py-16">
          <div className="max-w-4xl text-center">
            {/* Error Code & Logo */}
            <div className="mb-8">
              <img
                src="https://smfuwrmdonlmchctxvjq.supabase.co/storage/v1/object/public/logo/logo.png"
                alt="AMMING"
                className="h-16 md:h-20 w-auto mx-auto mb-6 brightness-0"
              />
              <h1 className="text-6xl md:text-8xl font-bold text-primary-brand mb-4">
                404
              </h1>
            </div>

            {/* Error Message */}
            <div className="mb-12">
              <h2 className="text-2xl md:text-3xl font-semibold text-primary-brand mb-4">
                Seite nicht gefunden
              </h2>
              <p className="text-lg text-amming-gray mb-6 max-w-2xl mx-auto leading-relaxed">
                Die angeforderte Seite existiert leider nicht oder wurde verschoben. 
                Kein Problem – wir helfen Ihnen gerne weiter!
              </p>
            </div>

            {/* Action Buttons */}
            <div className="mb-12 flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/"
                className="btn btn-primary inline-flex items-center gap-2 hover-lift"
              >
                <Home className="w-5 h-5" />
                Zur Startseite
              </Link>
              <button
                onClick={() => window.history.back()}
                className="btn btn-outline inline-flex items-center gap-2 hover-lift"
              >
                <ArrowLeft className="w-5 h-5" />
                Zurück
              </button>
            </div>

            {/* Suggested Pages */}
            <div className="mb-12">
              <h3 className="text-xl font-semibold text-primary-brand mb-6">
                Vielleicht suchen Sie nach:
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-3xl mx-auto">
                {suggestedPages.map((page) => (
                  <Link
                    key={page.name}
                    to={page.href}
                    className="bg-amming-light rounded-xl p-6 text-left hover:bg-gradient-subtle transition-all duration-300 group card-elegant"
                  >
                    <h4 className="font-semibold text-primary-brand mb-2 group-hover:text-amming-secondary transition-colors">
                      {page.name}
                    </h4>
                    <p className="text-amming-gray text-sm">
                      {page.description}
                    </p>
                  </Link>
                ))}
              </div>
            </div>

            {/* Contact Information */}
            <div className="bg-gradient-subtle rounded-xl p-6 md:p-8 max-w-2xl mx-auto card-elegant">
              <h3 className="text-xl font-semibold text-primary-brand mb-4">
                Benötigen Sie Hilfe?
              </h3>
              <p className="text-amming-gray mb-6">
                Unser Team steht Ihnen gerne zur Verfügung und hilft Ihnen bei der Navigation 
                auf unserer Website oder beantwortet Ihre Fragen zu unseren Bauleistungen.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a
                  href="tel:+4915770305796"
                  className="bg-primary-brand text-white px-6 py-3 rounded-xl font-medium hover:bg-primary-brand/90 transition-all duration-300 inline-flex items-center gap-2 justify-center shadow-elegant hover:shadow-elegant-lg hover:-translate-y-0.5"
                >
                  <Phone className="w-4 h-4" />
                  +49 157 7030 5796
                </a>
                <a
                  href="mailto:am@amming.de"
                  className="border-2 border-primary-brand text-primary-brand px-6 py-3 rounded-xl font-medium hover:bg-primary-brand hover:text-white transition-all duration-300 inline-flex items-center gap-2 justify-center"
                >
                  <Mail className="w-4 h-4" />
                  am@amming.de
                </a>
              </div>
            </div>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
};

export default NotFound;
